$(function(){

    $('[js-office-oauth-detach]').on('click', function(e){
        e.preventDefault();

        if(!confirm('Открепить соц. сеть от вашего аккаунта?')){
            return;
        }

        var $button = $(this).prop('disable', true);
        $.ajax({
            url: $button.attr('href'),
            type: 'post',
            dataType: 'json',
            success: function(){
            }
        });

        $button.fadeOut(300, function(){
            $button.remove();
        });
    });


    $('[js-office-profile-form]').each(function(){
        var $form = $(this),
            $success = $form.find('.form__success');

        $success.stop().slideUp(300);

        $form.formHandle({
            overlay: true,
            success: function(response){
                if(response.message){
                    $success.text(response.message).slideDown(300).delay(2000).slideUp(300);
                }

                if (response.email_confirm) {
                    $form.find('[js-email-confirm-input]').find('.input__message').remove();
                    let $message = $('<span>').addClass('input__message').text(response.email_confirm).hide().appendTo($form.find('[js-email-confirm-input]'));
                    $message.fadeIn(300).delay(2000).fadeOut(300);
                }
            }
        });
    });

    $('[js-office-password-form]').each(function(){
        var $form = $(this),
            $success = $form.find('.form__success');

        $success.stop().slideUp(300);

        $form.formHandle({
            overlay: true,
            success: function(response){
                if(response.message){
                    $success.text(response.message).slideDown(300).delay(2000).slideUp(300);
                }
            }
        });
    });

    $('[js-office-contract-freeze]').on('click', function(e){
        e.preventDefault();
        var completed = false;
        $$.openModal('office-freeze-form-' + $(this).data('id'), {
            afterOpen: function(modal, $modal){
                $modal.find('form').formHandle({
                    overlay: true,
                    success: function(response, $form){
                        completed = true;
                        $form.slideUp(300, function(){
                            var $message = $('<div class="form-message"/>').text(response.message)
                                .append(
                                    $('<div class="form__actions"><button class="button" type="submit"><span>Закрыть</span></button></div>')
                                        .on('click', function(e){
                                            e.preventDefault();
                                            $modal.arcticmodal('close');
                                        })
                                );

                            $form.after($message);
                            $message.hide().slideDown(300);
                        });
                    }
                });
            },
            afterClose: function(){
                if(completed){
                    document.location.reload();
                }
            }
        });
    });

    if (window.location.hash === '#equipment') {
        var $equipmentBlock = $('#equipment');
        var eqOffset = $equipmentBlock.offset().top;
        $('html, body').animate({
            scrollTop: eqOffset - 55
        }, 2000);
        return false;
    }

    if (window.location.hash === '#buy-section') {
        $('[js-ecommerce-section-buy]').trigger('click');
    }
});